class ProductPacks {
  constructor(container) {
    this.container = container;
    this.sectionId = container.dataset.sectionId;
    this.currentPack = null;
    this.init();
  }

  init() {
    this.setupPackSelection();
    this.setupAddToCart();
  }

  setupPackSelection() {
    const radioButtons = this.container.querySelectorAll('.pack-radio');
    
    // Guardar el estado previo de cada radio
    const radioStates = new Map();
    radioButtons.forEach(radio => {
      radioStates.set(radio, radio.checked);
    });
    
    radioButtons.forEach(radio => {
      // Usar click en lugar de change para capturar el toggle
      radio.addEventListener('click', (e) => {
        const wasChecked = radioStates.get(radio);
        
        if (wasChecked) {
          // Si ya estaba seleccionado, deseleccionar
          e.preventDefault();
          radio.checked = false;
          radioStates.set(radio, false);
          
          // Colapsar el contenido
          const packItem = radio.closest('.pack-item');
          packItem.classList.remove('pack-selected');
          const content = packItem.querySelector('.pack-content');
          if (content) {
            content.style.display = 'none';
          }
          this.currentPack = null;
          console.log('Pack deseleccionado');
        } else {
          // Deseleccionar todos
          radioButtons.forEach(r => {
            r.checked = false;
            radioStates.set(r, false);
            const packItem = r.closest('.pack-item');
            packItem.classList.remove('pack-selected');
            const content = packItem.querySelector('.pack-content');
            if (content) {
              content.style.display = 'none';
            }
          });
          
          // Seleccionar este
          radio.checked = true;
          radioStates.set(radio, true);
          this.selectPack(radio.value);
          console.log('Pack seleccionado:', radio.value);
        }
      });
    });

    // Seleccionar el pack inicial si hay uno marcado
    const checkedRadio = this.container.querySelector('.pack-radio:checked');
    if (checkedRadio) {
      radioStates.set(checkedRadio, true);
      this.selectPack(checkedRadio.value);
    }
  }

  selectPack(packId) {
    // Desmarcar todos los packs (solo estilo)
    const allPacks = this.container.querySelectorAll('.pack-item');
    allPacks.forEach(pack => {
      pack.classList.remove('pack-selected');
      const content = pack.querySelector('.pack-content');
      if (content) {
        content.style.display = 'none';
      }
    });

    // Marcar el pack seleccionado y mostrar su contenido
    const selectedPack = this.container.querySelector(`[data-pack-id="${packId}"]`);
    if (selectedPack) {
      selectedPack.classList.add('pack-selected');
      const content = selectedPack.querySelector('.pack-content');
      if (content) {
        content.style.display = 'block';
      }
      this.currentPack = selectedPack;
      
      // ============================================
      // 🎯 INICIALIZAR FILTRADO DINÁMICO DE VARIANTES
      // ============================================
      this.setupDynamicVariantFiltering(selectedPack);
    }
  }

  // ============================================
  // 🎯 CONFIGURAR FILTRADO DINÁMICO DE VARIANTES
  // ============================================
  setupDynamicVariantFiltering(packElement) {
    console.log('🔧 Configurando filtrado dinámico de variantes...');
    
    // Obtener el producto
    const productJson = packElement.querySelector('[data-product-json]');
    if (!productJson) {
      console.error('❌ No se encontró [data-product-json]');
      return;
    }

    let product;
    try {
      product = JSON.parse(productJson.textContent);
    } catch (e) {
      console.error('❌ Error al parsear JSON:', e);
      return;
    }

    // Configurar cada fila de producto
    const rows = packElement.querySelectorAll('.pack-row');
    rows.forEach(row => {
      const selectors = row.querySelectorAll('.variant-select');
      
      // Filtrar opciones iniciales
      this.filterVariantOptions(row, selectors, product);
      
      // 🖼️ Actualizar imagen inicial
      this.updateRowImage(row, product);
      
      // Agregar listeners para actualizar en tiempo real
      selectors.forEach(select => {
        select.addEventListener('change', () => {
          console.log('🔄 Opción cambiada, actualizando filtros...');
          this.filterVariantOptions(row, selectors, product);
          // 🖼️ ACTUALIZAR IMAGEN
          this.updateRowImage(row, product);
        });
      });
    });

    // ============================================
    // 🎁 CONFIGURAR FILTRADO PARA PRODUCTO BONUS
    // ============================================
    const bonusJson = packElement.querySelector('[data-bonus-product-json]');
    if (bonusJson) {
      try {
        const bonusData = JSON.parse(bonusJson.textContent);
        const bonusProduct = bonusData.product;
        
        const bonusSelectors = packElement.querySelectorAll('.bonus-variant-select');
        if (bonusSelectors.length > 0) {
          console.log('🎁 Configurando filtrado para producto bonus...');
          
          const bonusWrapper = packElement.querySelector('.bonus-selector-wrapper');
          
          // Filtrar opciones iniciales del bonus
          this.filterVariantOptions(bonusWrapper, bonusSelectors, bonusProduct);
          
          // 🖼️ Actualizar imagen inicial del bonus
          this.updateBonusImage(bonusWrapper, bonusProduct);
          
          // Agregar listeners
          bonusSelectors.forEach(select => {
            select.addEventListener('change', () => {
              console.log('🔄 Opción bonus cambiada, actualizando filtros...');
              this.filterVariantOptions(bonusWrapper, bonusSelectors, bonusProduct);
              // 🖼️ ACTUALIZAR IMAGEN DEL BONUS
              this.updateBonusImage(bonusWrapper, bonusProduct);
            });
          });
        }
      } catch (e) {
        console.error('❌ Error configurando bonus:', e);
      }
    }
  }

  // ============================================
  // 🔍 FILTRAR OPCIONES DE VARIANTES SEGÚN STOCK
  // ============================================
  filterVariantOptions(container, selectors, product) {
    if (!product.variants || product.variants.length === 0) return;

    console.log('🔍 Filtrando opciones...');
    
    // Obtener selecciones actuales
    const currentSelections = {};
    selectors.forEach(select => {
      const position = select.dataset.optionPosition;
      const value = select.value;
      if (value) {
        currentSelections[position] = value;
      }
    });

    console.log('Selecciones actuales:', currentSelections);

    // Filtrar cada selector
    selectors.forEach(select => {
      const position = select.dataset.optionPosition;
      const currentValue = select.value;
      
      console.log(`\n📋 Filtrando selector opción ${position}...`);

      // Obtener todas las opciones originales (guardadas en data-attribute)
      if (!select.dataset.originalOptions) {
        // Guardar opciones originales la primera vez
        const originalOptions = Array.from(select.options).map(opt => ({
          value: opt.value,
          text: opt.text
        }));
        select.dataset.originalOptions = JSON.stringify(originalOptions);
      }

      const originalOptions = JSON.parse(select.dataset.originalOptions);
      
      // Encontrar qué opciones tienen stock disponible
      const availableOptions = new Set();
      
      product.variants.forEach(variant => {
        // Verificar si esta variante está disponible
        if (!variant.available) return;
        
        // Verificar si coincide con las selecciones actuales (excepto esta posición)
        let matches = true;
        for (const [pos, val] of Object.entries(currentSelections)) {
          if (pos !== position) { // No verificar la posición actual
            const optionKey = `option${pos}`;
            if (variant[optionKey] !== val) {
              matches = false;
              break;
            }
          }
        }
        
        // Si coincide, agregar esta opción como disponible
        if (matches) {
          const optionKey = `option${position}`;
          availableOptions.add(variant[optionKey]);
        }
      });

      console.log(`  Opciones disponibles:`, Array.from(availableOptions));

      // Actualizar el select
      const selectedValue = select.value;
      select.innerHTML = ''; // Limpiar
      
      let hasValidSelection = false;
      
      originalOptions.forEach(opt => {
        const option = document.createElement('option');
        option.value = opt.value;
        option.text = opt.text;
        
        // Si esta opción NO tiene stock, no agregarla
        if (!availableOptions.has(opt.value) && opt.value !== '') {
          console.log(`  ❌ Ocultando: ${opt.text} (sin stock)`);
          return; // No agregar esta opción
        }
        
        // Agregar la opción
        select.appendChild(option);
        
        // Mantener la selección si es posible
        if (opt.value === selectedValue) {
          option.selected = true;
          hasValidSelection = true;
        }
      });

      // Si la selección anterior ya no está disponible, seleccionar la primera opción válida
      if (!hasValidSelection && select.options.length > 0) {
        // Buscar la primera opción que no sea vacía
        for (let i = 0; i < select.options.length; i++) {
          if (select.options[i].value !== '') {
            select.options[i].selected = true;
            console.log(`  ⚠️ Selección anterior no disponible, cambiando a: ${select.options[i].text}`);
            break;
          }
        }
      }
    });
  }

  // ============================================
  // 🖼️ ACTUALIZAR IMAGEN SEGÚN VARIANTE SELECCIONADA
  // ============================================
  updateRowImage(row, product) {
    const selectors = row.querySelectorAll('.variant-select');
    
    // Obtener valores seleccionados
    const selectedOptions = {};
    selectors.forEach(select => {
      const position = select.dataset.optionPosition;
      selectedOptions[position] = select.value;
    });
    
    // Encontrar la variante correspondiente
    const variant = this.findVariant(product, selectedOptions);
    
    if (variant) {
      const imageContainer = row.querySelector('.row-image img');
      
      if (imageContainer) {
        // Usar la imagen de la variante si existe, sino usar la imagen principal
        const imageUrl = variant.featured_image 
          ? variant.featured_image.src 
          : (product.featured_image ? product.featured_image : null);
        
        if (imageUrl) {
          // Crear URL optimizada con Shopify
          // 🖼️ Resolución subida de 80px a 700px para que se vea nítida
          // en el nuevo diseño de tarjeta (imagen grande)
          const optimizedUrl = imageUrl.includes('?') 
            ? imageUrl.split('?')[0] + '?width=700'
            : imageUrl + '?width=700';
          
          // Actualizar la imagen con una pequeña animación
          imageContainer.style.opacity = '0.5';
          imageContainer.src = optimizedUrl;
          
          imageContainer.onload = () => {
            imageContainer.style.opacity = '1';
          };
          
          console.log(`🖼️ Imagen actualizada para variante: ${variant.title}`);
        }
      }
    }
  }

  // ============================================
  // 🎁 ACTUALIZAR IMAGEN DEL PRODUCTO BONUS
  // ============================================
  updateBonusImage(bonusWrapper, bonusProduct) {
    const selectors = bonusWrapper.querySelectorAll('.bonus-variant-select');
    
    // Obtener valores seleccionados
    const selectedOptions = {};
    selectors.forEach(select => {
      const position = select.dataset.optionPosition;
      selectedOptions[position] = select.value;
    });
    
    // Encontrar la variante correspondiente
    const variant = this.findVariant(bonusProduct, selectedOptions);
    
    if (variant) {
      const imageContainer = bonusWrapper.querySelector('.bonus-image img');
      
      if (imageContainer) {
        const imageUrl = variant.featured_image 
          ? variant.featured_image.src 
          : (bonusProduct.featured_image ? bonusProduct.featured_image : null);
        
        if (imageUrl) {
          // 🖼️ Resolución subida de 60px a 300px
          const optimizedUrl = imageUrl.includes('?') 
            ? imageUrl.split('?')[0] + '?width=300'
            : imageUrl + '?width=300';
          
          imageContainer.style.opacity = '0.5';
          imageContainer.src = optimizedUrl;
          
          imageContainer.onload = () => {
            imageContainer.style.opacity = '1';
          };
          
          console.log(`🎁 Imagen bonus actualizada: ${variant.title}`);
        }
      }
    }
  }

  setupAddToCart() {
    const addToCartButtons = this.container.querySelectorAll('.pack-add-to-cart');
    
    addToCartButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.addPackToCart(button);
      });
    });
  }

  async addPackToCart(button) {
    const packId = button.dataset.packId;
    const packElement = this.container.querySelector(`[data-pack-id="${packId}"]`);
    
    if (!packElement) {
      console.error('❌ Pack no encontrado:', packId);
      return;
    }

    // Verificar si el pack está seleccionado
    const radio = packElement.querySelector('.pack-radio');
    if (!radio || !radio.checked) {
      this.showNotification('⚠️ Por favor selecciona este pack primero haciendo clic en él', 'warning');
      return;
    }

    console.log('🛒 Iniciando proceso de añadir al carrito...');
    console.log('Pack ID:', packId);

    // Mostrar loading
    this.setButtonLoading(button, true);

    try {
      const items = await this.collectPackItems(packElement);
      
      if (items.length === 0) {
        throw new Error('No se pudieron obtener los productos del pack.');
      }

      console.log('📦 Intentando añadir items al carrito:', items);

      // Añadir todos los items al carrito
      const response = await this.addItemsToCart(items);
      
      if (response.ok) {
        console.log('✅ Items añadidos exitosamente:', response.data);
        this.onAddToCartSuccess(response);
      }
    } catch (error) {
      console.error('❌ Error general:', error);
      this.onAddToCartError(error.message);
    } finally {
      this.setButtonLoading(button, false);
    }
  }

  async collectPackItems(packElement) {
    const items = [];
    
    console.log('🔍 Iniciando recolección de items del pack...');
    
    // Obtener el producto base
    const productJson = packElement.querySelector('[data-product-json]');
    
    if (!productJson) {
      console.error('❌ No se encontró el elemento [data-product-json]');
      throw new Error('No se encontró la información del producto.');
    }

    let product;
    try {
      product = JSON.parse(productJson.textContent);
      console.log('✅ Producto parseado:', product);
    } catch (e) {
      console.error('❌ Error al parsear JSON del producto:', e);
      throw new Error('Error al leer la información del producto.');
    }
    
    // Recoger todas las filas de producto
    const rows = packElement.querySelectorAll('.pack-row');
    console.log(`📦 Encontradas ${rows.length} filas de producto`);
    
    if (rows.length === 0) {
      console.error('❌ No se encontraron filas de producto');
      throw new Error('No se encontraron productos en el pack.');
    }
    
    for (const row of rows) {
      const rowIndex = row.dataset.rowIndex;
      console.log(`\n🔹 Procesando fila #${rowIndex}`);
      
      const selectors = row.querySelectorAll('.variant-select');
      
      // Obtener los valores seleccionados
      const selectedOptions = {};
      selectors.forEach(select => {
        const optionPosition = select.dataset.optionPosition;
        const value = select.value;
        selectedOptions[optionPosition] = value;
        console.log(`  Opción ${optionPosition}: ${value}`);
      });
      
      // Encontrar la variante que coincida
      const variant = this.findVariant(product, selectedOptions);
      
      if (!variant) {
        throw new Error(`No se encontró la variante en la fila #${rowIndex}. Por favor, recarga la página.`);
      }
      
      if (!variant.available) {
        throw new Error(`La variante seleccionada en la fila #${rowIndex} ya no está disponible. Por favor, selecciona otra opción.`);
      }
      
      items.push({
        id: variant.id,
        quantity: 1,
        properties: {
          '_pack_item': `Fila #${rowIndex}`
        }
      });
      console.log(`  ✅ Añadida variante ${variant.id} al pack`);
    }

    // ============================================
    // BONUS PRODUCT
    // ============================================
    const bonusJson = packElement.querySelector('[data-bonus-product-json]');
    if (bonusJson) {
      console.log('\n🎁 Procesando producto bonus...');
      try {
        const bonusData = JSON.parse(bonusJson.textContent);
        const bonusProduct = bonusData.product;
        const bonusQuantity = bonusData.quantity || 1;
        
        const bonusSelects = packElement.querySelectorAll('.bonus-variant-select');
        let bonusVariant = null;
        
        if (bonusSelects.length > 0) {
          // Bonus con selectores
          const bonusSelectedOptions = {};
          bonusSelects.forEach(select => {
            const selectedValue = select.value;
            const bonusOptionPosition = select.dataset.optionPosition;
            bonusSelectedOptions[bonusOptionPosition] = selectedValue;
          });
          
          bonusVariant = this.findVariant(bonusProduct, bonusSelectedOptions);
          
        } else {
          // Bonus sin selectores - primera variante disponible
          if (bonusProduct.variants && bonusProduct.variants.length > 0) {
            bonusVariant = bonusProduct.variants.find(v => v.available);
            
            if (!bonusVariant) {
              bonusVariant = bonusProduct.variants[0];
            }
          }
        }
        
        if (!bonusVariant) {
          throw new Error('No se encontró el producto regalo. Por favor, recarga la página.');
        }
        
        if (!bonusVariant.available) {
          throw new Error('El producto regalo ya no está disponible. Por favor, selecciona otra opción.');
        }
        
        items.push({
          id: bonusVariant.id,
          quantity: bonusQuantity,
          properties: {
            '_pack_bonus': 'Regalo del pack'
          }
        });
        console.log(`✅ Añadida variante bonus ${bonusVariant.id} (cantidad: ${bonusQuantity})`);
        
      } catch (e) {
        console.error('❌ Error procesando bonus:', e);
        if (e.message) throw e;
        throw new Error('Error al procesar el producto regalo.');
      }
    }

    console.log('\n📋 Items finales a añadir al carrito:', items);
    return items;
  }

  findVariant(product, selectedOptions) {
    if (!product.variants) {
      console.error('El producto no tiene variantes');
      return null;
    }

    // Si el producto tiene solo una variante, devolverla directamente
    if (product.variants.length === 1) {
      return product.variants[0];
    }

    // Si no hay opciones seleccionadas, retornar la primera variante disponible
    if (Object.keys(selectedOptions).length === 0) {
      return product.variants.find(v => v.available) || product.variants[0];
    }

    // Buscar la variante que coincida con todas las opciones seleccionadas
    const variant = product.variants.find(variant => {
      let matches = true;
      
      for (const [position, value] of Object.entries(selectedOptions)) {
        const optionKey = `option${position}`;
        
        if (variant[optionKey] !== value) {
          matches = false;
          break;
        }
      }
      
      return matches;
    });

    return variant || null;
  }

  async addItemsToCart(items) {
    console.log('🚀 Enviando petición al carrito de Shopify...');
    console.log('📦 Items a enviar:', JSON.stringify(items, null, 2));
    
    const cart = document.querySelector("cart-drawer") || 
                 document.querySelector("cart-notification");
    
    let sections = [];
    let sectionsUrl = window.location.pathname;
    
    if (cart && typeof cart.getSectionsToRender === 'function') {
      sections = cart.getSectionsToRender().map((section) => section.id);
      console.log('📋 Secciones a actualizar:', sections);
    }
    
    try {
      const response = await fetch(`${routes.cart_add_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ 
          items,
          sections: sections,
          sections_url: sectionsUrl
        })
      });

      console.log('📡 Respuesta del servidor:', response.status, response.statusText);
      
      if (!response.ok) {
        const errorData = await response.json();
        console.error('❌ Error del servidor:', errorData);
        throw new Error(errorData.description || errorData.message || 'Error al añadir al carrito');
      }
      
      const data = await response.json();
      console.log('✅ Respuesta exitosa:', data);
      
      return { ok: true, data, cart };
    } catch (error) {
      console.error('❌ Error en fetch:', error);
      throw error;
    }
  }

  setButtonLoading(button, isLoading) {
    const btnText = button.querySelector('.btn-text');
    const btnLoading = button.querySelector('.btn-loading');
    
    if (isLoading) {
      button.disabled = true;
      button.classList.add('loading');
      if (btnText) btnText.style.display = 'none';
      if (btnLoading) btnLoading.style.display = 'inline-block';
    } else {
      button.disabled = false;
      button.classList.remove('loading');
      if (btnText) btnText.style.display = 'inline-block';
      if (btnLoading) btnLoading.style.display = 'none';
    }
  }

  onAddToCartSuccess(responseData) {
    console.log('✅ Pack añadido exitosamente al carrito');
    
    const { data, cart } = responseData;
    
    if (data.sections && cart) {
      console.log('🔄 Actualizando HTML del minicart...');
      
      if (typeof cart.getSectionsToRender === 'function') {
        cart.getSectionsToRender().forEach((section) => {
          const elementToReplace = document.getElementById(section.id);
          if (elementToReplace && data.sections[section.id]) {
            const html = new DOMParser().parseFromString(
              data.sections[section.id],
              "text/html"
            );
            const minicartForm = html.querySelector("#minicart-form");
            if (minicartForm) {
              elementToReplace.innerHTML = minicartForm.innerHTML;
              console.log(`✅ Sección ${section.id} actualizada`);
            }
          }
        });
        
        const countdown = cart.querySelector(".cart-countdown-time");
        if (countdown && data.sections) {
          const sectionId = Object.keys(data.sections)[0];
          if (sectionId) {
            const html = new DOMParser().parseFromString(
              data.sections[sectionId],
              "text/html"
            );
            const html_countdown = html.querySelector(".cart-countdown-time");
            if (html_countdown) {
              countdown.innerHTML = html_countdown.innerHTML;
            }
          }
        }
        
        if (typeof cart.cartAction === 'function') {
          cart.cartAction();
        }
      }
    }
    
    fetch("/cart.json")
      .then((res) => res.json())
      .then((cartData) => {
        console.log('📊 Estado del carrito:', cartData);
        
        if (cartData.item_count != undefined) {
          document.querySelectorAll(".cart-count").forEach((el) => {
            if (el.classList.contains("cart-count-drawer")) {
              el.innerHTML = `(${cartData.item_count})`;
            } else {
              el.innerHTML = cartData.item_count > 100 ? '~' : cartData.item_count;
            }
          });
          console.log(`✅ Contador actualizado: ${cartData.item_count} items`);
          
          if (document.querySelector("header-total-price")) {
            document.querySelector("header-total-price").updateTotal(cartData);
            console.log('✅ Header total price actualizado');
          }
          
          const cart_free_ship = document.querySelector("free-ship-progress-bar");
          if (cart_free_ship) {
            cart_free_ship.init(cartData.items_subtotal_price);
            console.log('✅ Barra de envío gratis actualizada');
          }
        }
      })
      .catch((error) => {
        console.error('❌ Error al actualizar el carrito:', error);
      });
    
    if (cart) {
      console.log('✅ Abriendo cart drawer...');
      
      if (typeof cart.open === 'function') {
        cart.open();
      } else {
        cart.classList.add('active', 'open');
      }
      
      const cartRecommend = document.querySelector(".cart-recommend");
      if (cartRecommend && !cartRecommend.classList.contains("hidden-recommend")) {
        if (cartRecommend.classList.contains('cart-recommend-custom')) {
          const cartUpsellItem = document.querySelectorAll('.cart-upsell-item');
          const cartUpsellSlide = document.querySelectorAll('.swiper-cart-upsell .swiper-slide');
          if (cartUpsellItem.length > 0) {
            setTimeout(() => {
              cartRecommend.classList.add("open");
            }, 800);
          } else if (cartUpsellSlide.length === 0) {
            cartRecommend.classList.remove('block');
            cartRecommend.classList.add('hidden');
          }
        } else {
          setTimeout(() => {
            cartRecommend.classList.add("open");
          }, 800);
        }
      }
    }
  }

  onAddToCartError(message) {
    console.error('❌ Error al añadir al carrito:', message);
    
    if (typeof showToast === 'function') {
      const errorHTML = `
        <div class="inline-flex align-center">
          <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
          <span class="ml-5">${message}</span>
        </div>
      `;
      showToast(errorHTML, 5000, 'modal-error');
    } else {
      alert(message);
    }
  }

  showNotification(message, type = 'info') {
    console.log(`${type === 'warning' ? '⚠️' : 'ℹ️'} ${message}`);
    
    if (typeof showToast === 'function') {
      const icon = type === 'warning' 
        ? '<svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg>'
        : '<svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>';
      
      const html = `
        <div class="inline-flex align-center">
          ${icon}
          <span class="ml-5">${message}</span>
        </div>
      `;
      showToast(html, 3000, type === 'warning' ? 'modal-warning' : 'modal-info');
    } else {
      alert(message);
    }
  }
}

// Inicializar cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', () => {
  const packContainers = document.querySelectorAll('.product-packs-section');
  packContainers.forEach(container => {
    new ProductPacks(container);
  });
});

// Reinicializar si Shopify secciones recarga la sección
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const container = event.target.querySelector('.product-packs-section');
    if (container) {
      new ProductPacks(container);
    }
  });
}
